import { isEmpty } from "lodash";
import { useEffect, useState } from "react";
import BasicPartner from "../../../src/images/Basic-Partner.png";
import ProPartner from "../../../src/images/Pro-Partner.png";
import PlusPartner from "../../../src/images/Plus-Partner.png";
import ElitePartner from "../../../src/images/Elite-Partner.png";
import LargePopupCertificate from "../LargePopupCertificate";
import { connect } from "react-redux";
import { hideLoading, showLoading } from "../../actions/loaderAction";
import defaultValues from "../../constant/defaultValues";
import { useAuth } from "@/AuthProvider";

function CompanyPlanInfo(props) {
  const { company_plan, is_expired  } = useAuth();
  const { IMAGE_PATH } = defaultValues;

  const [badgeSrc, setBadgeSrc] = useState("");
  const [planTo, setPlanTo] = useState("");
  const [planFrom, setPlanFrom] = useState("");
  const [planName, setPlanName] = useState("");
  const [largemodalShow, setLargeModalShow] = useState(false);
  const [certtificate,setCertificate] = useState("");
  const setData = () => {
    if (!isEmpty(props.data)) {
      setPlanTo(props.data.plan_to_date);
      setPlanFrom(props.data.plan_from_date);
      setPlanName(props.data.plan_name);
      setCertificate(props.data.orex_certificate);
      if (!isEmpty(props.data.badge)) {
        if (props.data.badge == "Elite") {
          setBadgeSrc(ElitePartner);
        } else if (props.data.badge == "Basic") {
          setBadgeSrc(BasicPartner);
        } else if (props.data.badge == "Pro") {
          setBadgeSrc(ProPartner);
        } else if (props.data.badge == "Plus") {
          setBadgeSrc(PlusPartner);
        }
      }

    }
  };



  useEffect(() => {
    setData();
  }, [props.data]);

  console.log(planName);
  console.log(company_plan);

  
  
  return (
    <>
      <h3>Company Plan Info</h3>
      {
        planName !== "Trial" && <div className="company-badge">
          <img src={badgeSrc} alt="" />
        </div>
      }

      <div className="other-info">
        <p>
          <b>Plan Name:</b> {planName}
        </p>
        <p>
          Plan Valid Up To <b>{planTo}</b>
        </p>
        {
          planName !== "Trial" && company_plan !== "Trial" && is_expired == 0 && <p>
            <button onClick={() => setLargeModalShow(true)} className="btn btn-primary small">View Certificate</button>
          </p>
        }

        {/* <p>Plan To: {planTo}</p>
        <p>Plan From: {planFrom}</p>
        <p>PDF URL: {!isEmpty(props.pdfUrl) ? props.pdfUrl : " - "}</p> */}
      </div>
      <LargePopupCertificate
        // title="Certificate"
        LargeModalShow={largemodalShow}
        setLargeModalShow={setLargeModalShow}
        pdfUrl={props.data && `${IMAGE_PATH.BASE_URL}${certtificate}`}
        // pdfUrl={props.data && IMAGE_PATH.BASE_URL + certtificate}
        pageSource="companyPlanInfo"
      >
      </LargePopupCertificate>
    </>
  );
}
const mapStateToProps = (state) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading()),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(CompanyPlanInfo);
